"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm.699 14.805h-1.56v-1.653h1.56v1.653zm.43-4.274l-.47.322v.995H11.18v-1.505l1.25-.887c.699-.498 1.116-.766 1.116-1.6 0-.645-.444-1.317-1.452-1.317-1.062 0-1.707.685-1.707 1.787H8.976c0-2.03 1.358-3.131 3.119-3.131 1.976 0 2.93 1.277 2.93 2.634 0 1.479-1.103 2.178-1.896 2.702z" }), "Guideline");
//# sourceMappingURL=Guideline.js.map